import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useActivityLog} from "../hooks/useActivityLog.ts";
import {ActivityLog} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useActivityLog();

    return (
        <FormDrawer
            record={{
                id: '',
                username: '',
                action: '',
                value: 0,
                recordId: '',
                usageType: '',
                recordType: '',
                created: new Date().toISOString(),
            } as ActivityLog}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
